/* eslint no-use-before-define: 0 */

import React, { Fragment } from "react";
import CustomWidthTooltip from "./CustomWidthTooltip";
import _ from "lodash";
import i18n from "i18next";
import styles from "./formikControl.module.scss";
import { Box, Switch, TextField } from "@mui/material";
import AutoComplete from "./AutoComplete/AutoComplete";
import Textarea from "./Textarea";
import MultiFieldSelect from "./MultiFieldSelect/MultiFieldSelect";
import DatePicker from "react-multi-date-picker";
import CustomDatepicker from "./customDatePicker/CustomDatePicker";
import { DutchMonths, DutchWeekDays } from "../../config/appConfig";
import ApiFilterMultiSelect from "./MultiFieldSelect/ApiFilterMultiSelect";
import PropTypes from "prop-types";

function FormikControl(props) {
  const {
    control,
    infoText,
    label,
    error,
    errorMessage,
    customClass,
    toolTipClass = "smallToolTip",
    addWrapper = true,
    oldValueText = {},
    helpertext = {},
    disabled = false,
    isHideLabel = false,
    onDatePickerChange,
    ...rest
  } = props;

  const getFormikControl = () => {
    switch (control) {
      case "textfield":
        return <TextField {...rest} disabled={disabled} />;
      case "autocomplete":
        return <AutoComplete {...rest} />;
      case "textarea":
        return <Textarea {...rest} />;
      case "multiselect": {
        return <MultiFieldSelect {...rest} disabled={disabled} />;
      }
      case "apiFilterMultiSelect": {
        return <ApiFilterMultiSelect {...rest} />;
      }
      case "switch":
        return <Box><Switch {...rest} />{label}</Box>;
      case "datepicker":
        return (
          <DatePicker
            months={DutchMonths}
            weekDays={DutchWeekDays}
            render={<CustomDatepicker {...rest} />}
            {...rest}
          />
        );

      default:
        return null;
    }
  };
  const customClassName = !_.isUndefined(styles[customClass])
    ? styles[customClass]
    : customClass;

  return (
    <Fragment>
      {addWrapper ? (
        <div
          data-testid="formikcontrol"
          className={`input-grp ${
            customClass
              ? customClassName
              : error
              ? `${styles.fieldWrapper} ${styles.inputError}`
              : styles.fieldWrapper
          }`}
        >
          <div
            className={`input-grp__label-grp ${
              disabled ? "disabledLabel" : ""
            }`}
          >
            {!_.isEmpty(label) && !isHideLabel ? (
              <label className="input-grp__label">
                {i18n.t(label)}
                {!_.isEmpty(infoText) ? (
                  <CustomWidthTooltip
                    title={infoText}
                    toolTipClass={toolTipClass}
                  >
                    <span
                      className={`icon icon-info-circle ${styles.infoIcon}`}
                    ></span>
                  </CustomWidthTooltip>
                ) : null}
              </label>
            ) : null}
          </div>
          <div className={styles.formControlContainer}>
            {getFormikControl()}

            {error ? <div className="error">{errorMessage}</div> : null}
            {!_.isEmpty(oldValueText) ? (
              <div>
                <span className={styles.oldTextLabel}>
                  {_.get(oldValueText, "label", "")}:
                </span>
                <span className={styles.oldTextValue}>
                  {_.get(oldValueText, "value", "")}
                </span>
              </div>
            ) : (
              ""
            )}

            {!_.isEmpty(helpertext) ? (
              <div className={styles.helperTextContainer}>
                <span className={styles.helpTextLabel}>
                  {_.get(helpertext, "label", "")}
                </span>
                <span className={styles.helpTextValue}>
                  {_.get(helpertext, "value", "")}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        getFormikControl()
      )}
    </Fragment>
  );
}

export default React.memo(FormikControl);
FormikControl.propTypes = {
  control: PropTypes.any,
  infoText: PropTypes.any,
  label: PropTypes.any,
  error: PropTypes.any,
  errorMessage: PropTypes.any,
  customClass: PropTypes.any,
  toolTipClass: PropTypes.any,
  addWrapper: PropTypes.any,
  oldValueText: PropTypes.any,
  helpertext: PropTypes.any,
  disabled: PropTypes.any,
  onDatePickerChange: PropTypes.any,
  isHideLabel: PropTypes.any
};
